import { render, staticRenderFns } from "./CompanyModuleSkeleton.vue?vue&type=template&id=281dd7d6&scoped=true&"
import script from "./CompanyModuleSkeleton.vue?vue&type=script&lang=js&"
export * from "./CompanyModuleSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CompanyModuleSkeleton.vue?vue&type=style&index=0&id=281dd7d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281dd7d6",
  null
  
)

export default component.exports